import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Output, OutputGraph, Unit } from '../devices/devices.interfaces';

@Injectable({
  providedIn: 'root',
})

/**
 * DEPRECATED - use FunctionBlockService
 */
export class OutputsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get Output by id
   * @param id Output id
   */
  getOutput(id: number): Observable<Output> {
    const url = `${this.globals.apiRoot}/jwtoutputs/${id}`;
    return this.http.get<Output>(url);
  }

  /**
   * Updates One output name,icon and readOnly status
   * @param output the output to be updated
   */
  updateOutput(output: Output): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtoutputs/${output.id}`;
    return this.http.put<void>(url, output);
  }

  /**
   * gets all the graphs for this output
   * @param outputId the id of the output
   */
  getOuputGraph(outputId: number): Observable<OutputGraph[]> {
    const url = `${this.globals.apiRoot}/jwtoutputs/${outputId}/graph`;
    return this.http.get<OutputGraph[]>(url);
  }

  getOutputUnit(outputId: number): Observable<Unit> {
    const url = `${this.globals.apiRoot}/jwtoutputs/${outputId}/unit`;
    return this.http.get<Unit>(url);
  }
}
